import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4b54366d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "dashboard" }
const _hoisted_2 = { class: "equal-height-col" }
const _hoisted_3 = { class: "equal-height-col" }
const _hoisted_4 = { class: "equal-height-col" }
const _hoisted_5 = { class: "equal-height-col" }
const _hoisted_6 = { class: "equal-height-col" }

import { onMounted, onUnmounted, ref } from 'vue'
import StationStatusCard from './components/StationStatusCard.vue'
import CurrentAlarmsCard from './components/CurrentAlarmsCard.vue'
import GenerationStats from './components/GenerationStats.vue'
import LowCarbonCard from './components/LowCarbonCard.vue'
import EnergyAnalysis from './components/EnergyAnalysis.vue'
import { GetEssAlarmStatus, GetEssStationOverview, GetEssStationStatus } from '@/api/evses'
import { GetEssAlarmStatusReply, GetEssStationStatusReply } from '@/types/types'
import { GetEssStationOverviewReply } from '@/types/common/station'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const stationData = ref({
  normal: 0,
  alarm: 0,
  unmonitored: 0,
  stationCount: 0,
})

const generationData = ref({
  efficiency: 0,
  today: 0,
  thisYear: 0,
  thisMonth: 0,
  cumulative: 0,
  installedCapacity: 0,
  currentPower: 0,
  genEnergyRate: 0,
})

const alarmData = ref({
  urgent: 0,
  important: 0,
  general: 0,
})
let timer: ReturnType<typeof setTimeout> | null = null
const fetchEssStationStatus = () => {
  GetEssStationStatus().then((res: GetEssStationStatusReply) => {
    stationData.value = {
      normal: res?.monitorCount,
      alarm: res?.alarmCount ?? 0, // Removed because 'alarm' does not exist on the type
      unmonitored: res.otherCount ?? 0,
      stationCount: res.stationCount ?? 0,
    }
  })
}

const fetchEssAlarmStatusReply = () => {
  GetEssAlarmStatus().then((res: GetEssAlarmStatusReply) => {
    alarmData.value = {
      urgent: res?.crashCount || 0,
      important: res?.importantCount || 0,
      general: res?.minorCount || 0,
    }
  })
}

const fetchEssStationOverview = () => {
  // TODO update GetEssStationOverviewReply interface
  GetEssStationOverview().then((res: GetEssStationOverviewReply) => {
    generationData.value = {
      efficiency: res.genEnergyRate,
      today: res.todaysGenEnergy,
      thisYear: res.yearlyGenEnergy,
      thisMonth: res.monthlyGenEnergy,
      cumulative: res.totalGenEnergy,
      installedCapacity: res.totalCapacity,
      currentPower: res.genEnergyPower,
      genEnergyRate: res.genEnergyRate,
    }
  })
}
const initFetchData = () => {
  fetchEssAlarmStatusReply()
  fetchEssStationStatus()
  fetchEssStationOverview()
}

onMounted(() => {
  timer = setTimeout(() => initFetchData(), 3000)
})
onUnmounted(() => {
  if (timer) {
    clearTimeout(timer)
  }
})
// 你可以稍后改变这些值来测试响应式
// setTimeout(() => {
//   stationData.value.normal = 5;
//   alarmData.value.important = 4;
// }, 3000);

return (_ctx: any,_cache: any) => {
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_row, { gutter: 20 }, {
      default: _withCtx(() => [
        _createVNode(_component_el_col, { span: 12 }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(GenerationStats, { stats: generationData.value }, null, 8, ["stats"])
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_el_col, { span: 6 }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(StationStatusCard, { "status-data": stationData.value }, null, 8, ["status-data"])
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_el_col, { span: 6 }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(CurrentAlarmsCard, { "status-data": alarmData.value }, null, 8, ["status-data"])
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_el_col, { span: 12 }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_5, [
              _createVNode(EnergyAnalysis, { stats: generationData.value }, null, 8, ["stats"])
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_el_col, { span: 12 }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_6, [
              _createVNode(LowCarbonCard, { stats: generationData.value }, null, 8, ["stats"])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}
}

})